import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    const getQuery = (paramsData) => {
      return getParams(paramsData) !== "" ? `&${getParams(paramsData)}` : "";
    };


    try {
      let url =
        method !== "post"
          ? `${endpoint}?${getParams("sort_by")}&sort_order=${
              params?.sort_order || "desc"
            }&length=${params?.length || "10"}&${getParams("search")}&page=${
              params?.page || 1
            }${getQuery("franchise_id")}${getQuery(
              "start_date"
            )}${getQuery("end_date")}`
          : `${endpoint}`;

      const response = await api[method](url, body);

      if (response?.data?.data?.rows !== undefined) {
        return { data: response?.data?.data };
      } else {
        return { data: response?.data };
      }
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const surrender = createApi({
  reducerPath: "surrendersApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Surrenders"],
  endpoints: (builder) => ({
    getSurrendersListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        refetchOnMountOrArgChange: true ,
        endpoint: `/v1/surrender/filters`,
      }),
      providesTags: ["Surrenders"],
    }),
    updateSurrendersListData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/table-permission-create`,
      }),

      invalidatesTags: ["Surrenders"],
    }),
    updateSurrenderDataByID: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/staffs/update`,
      }),

      invalidatesTags: ["Surrenders"],
    }),
  
    // STOP HERE
  }),
});

export const {
  useGetSurrendersListDataQuery,
  useUpdateSurrendersListDataMutation,
} = surrender;
